module.exports = __webpack_public_path__ + "static/media/PremiumBeat_0013_cursor_selection_15.2d2a0a6e.wav";